/** Card processing fee from business settings (percent of subtotal). */
export function calcCardProcessingFee(subtotal: number, feePercent: number): number {
  if (feePercent <= 0 || subtotal <= 0) return 0
  return (subtotal * feePercent) / 100
}

export function calcCheckoutTotal(
  subtotal: number,
  feePercent: number,
  paymentMethod: 'card' | 'ach'
): number {
  if (paymentMethod === 'ach') return subtotal
  return subtotal + calcCardProcessingFee(subtotal, feePercent)
}
